import { useTranslation } from 'react-i18next';
import { BodyConfirmModal } from '../../components/modals/body/body_confirm_modal.component';
import { InfoModal } from '../../components/modals/info_modal.component';

interface ConfirmDeleteModalProps {
  isOpen: boolean;
  elementsCount: { fileCount: number, folderCount: number };
  hasCross?: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
export function ConfirmDeleteModal( { isOpen, elementsCount, hasCross, onClose, onConfirm }: ConfirmDeleteModalProps ) {
  const { t } = useTranslation();

  const close = () => {
    if ( onClose ) {
      onClose();
    }
  };

  const confirm = () => {
    onConfirm();
    close();
  };

  return (
    <InfoModal
      id={ 'confirm_nav_modal' }
      title={ t( 'Are you sure ?' ) }
      isOpen={ isOpen }
      onClose={ close }
      hasCross={ hasCross }
    >
      <BodyConfirmModal
        onCancel={ close }
        onConfirm={ confirm }
        confirmColor='#4986f3'
        confirmColorHover='#3579F2'
      >
        <div className='flex flex-col gap-1 px-8 py-4 text-[16px]'>
          <span>
            { t( 'confirm_delete_dir_file', { fileCount: elementsCount.fileCount, folderCount: elementsCount.folderCount } ) }
          </span>
          <span>
            { t( 'you_sure_that' ) }
          </span>
        </div>
      </BodyConfirmModal>
    </InfoModal>
  );
}
